import D4SIGN from './d4sign/_settings'
import { GOOGLE_CALENDAR } from './google/settings'
import { SLACK } from './slack/_settings'
import { TWILIO } from './twilio/_settings'
import { CHAT_PRO } from './chat_pro/_settings'
import SEGWARE from './segware/_settings'

export const SETTINGS = {
  slack: SLACK,
  google: GOOGLE_CALENDAR,
  d4sign: D4SIGN,
  twilio: TWILIO,
  chat_pro: CHAT_PRO,
  segware: SEGWARE
}

export const ALLOWED_QUESTIONS_AND_FIELDS_INTEGRATIONS = ['omie', 'nibo']
